import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/client/PartnersPage/PartnersPage.tsx");
